import { h } from 'vue'

let marqueeStyleAdded = false

function injectMarqueeStyles() {
    if (typeof document === 'undefined' || marqueeStyleAdded) return

    const style = document.createElement('style')
    style.id = 'custom-marquee-styles'
    style.textContent = `
    .custom-marquee {
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      position: relative;
      display: block;
    }

    .custom-marquee__track {
      display: inline-block;
      min-width: 100%;
      padding-left: 100%;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-name: custom-marquee-left;
    }

    .custom-marquee--right .custom-marquee__track {
      padding-left: 0;
      padding-right: 100%;
      animation-name: custom-marquee-right;
    }

    .custom-marquee--pause:hover .custom-marquee__track {
      animation-play-state: paused;
    }

    @keyframes custom-marquee-left {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-100%);
      }
    }

    @keyframes custom-marquee-right {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(100%);
      }
    }
  `
    document.head.appendChild(style)
    marqueeStyleAdded = true
}

export default {
    name: 'Marquee',

    props: {
        speed: {
            type: Number,
            default: 10
        },
        color: {
            type: String,
            default: ''
        },
        pauseOnHover: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'left',
            validator: (value) => ['left', 'right'].includes(value)
        }
    },

    setup(props, { slots }) {
        injectMarqueeStyles()

        return () =>
            h(
                'div',
                {
                    class: [
                        'custom-marquee',
                        props.pauseOnHover ? 'custom-marquee--pause' : '',
                        props.direction === 'right' ? 'custom-marquee--right' : ''
                    ],
                    style: {
                        color: props.color || undefined
                    }
                },
                [
                    h(
                        'div',
                        {
                            class: 'custom-marquee__track',
                            style: {
                                animationDuration: `${props.speed}s`
                            }
                        },
                        slots.default ? slots.default() : ''
                    )
                ]
            )
    }
}